import React, { useState } from "react";
import Modal from "sushiweb/Modal";
import TableFields from "../../../constants/LifeLine/OrderItemsTableFields.json";
import { isEmpty } from "../../../utils";
import styled from "styled-components";
import Table from "../../Common/Table";
import { OrderBag } from "sushiweb/Icons";

const OrderInfo = (props) => {
  const { data } = props;
  const [showModal, setShowModal] = useState(false);

  const getFieldValue = (obj, key) => {
    switch (key) {
      case "item_price":
        return "₹" + obj[key];
      case "value":
        return "₹" + obj["quantity"] * obj["item_price"];
      default:
        return obj[key];
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleDoClick = () => {
    if (isEmpty(data)) {
      return;
    }
    setShowModal(true);
  };

  return [
    <OrderInfoContainer>
      <OrderItemStyle onClick={handleDoClick}>
        <OrderBag size="1rem"></OrderBag>
        <b> Order Items </b>
      </OrderItemStyle>
    </OrderInfoContainer>,
    <>
      {showModal && (
        <Modal
          visible={showModal}
          onClose={handleClose}
          type="medium"
          showCloseIcon={true}
          slideOnMobile
          isCentered
          padding="2rem"
          preventFocus
        >
          {
            <Table
              list={data}
              getFieldValue={getFieldValue}
              fields={TableFields}
            />
          }
        </Modal>
      )}
    </>,
  ];
};

const OrderItemStyle = styled.div`
  display: flex;
  cursor: pointer;
  b {
    padding-left: 2px;
  }
`;

const OrderInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default OrderInfo;
